module.exports = __webpack_public_path__ + "./images/redscooter.122377.svg";